import { render } from "./FerramentasView.vue?vue&type=template&id=2d4f5e0b&scoped=true"
import script from "./FerramentasView.vue?vue&type=script&lang=js"
export * from "./FerramentasView.vue?vue&type=script&lang=js"

import "./FerramentasView.vue?vue&type=style&index=0&id=2d4f5e0b&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4f5e0b"]])

export default __exports__